import React, { FC } from "react";

import { RequiredButtonProps } from "@intelligems/ig-types";
import { ensureString } from "@intelligems/ig-utils";

import { ExtraMessage } from "../ExtraMessage";
import { PriceSection } from "../PriceSection";

export const QuantityWidget1: FC<RequiredButtonProps> = ({
  button,
  unitDiscount,
  mode,
  discountedUnitPrice,
}) => {
  return (
    <>
      <ExtraMessage
        quantity={button.quantity}
        unitDiscount={unitDiscount}
        message={
          button.extraMessage ? ensureString(button.extraMessage) : undefined
        }
        fullPriceMessage={button.fullPriceMessage}
        mode={mode}
      />
      <PriceSection discountedUnitPrice={discountedUnitPrice} button={button} />
    </>
  );
};
